import React from 'react';
import './Footer.css';
import { FaLinkedin, FaXTwitter, FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa6';

export default function Footer() {
  return (
    <footer
      className="footer"
      style={{
        backgroundImage: "url('/background.png')",
        backgroundRepeat: 'repeat',
        backgroundPosition: 'bottom',
        backgroundSize: 'auto'
      }}
    >
      <div className="footer-content">
        <div className="footer-brand">
          <h2>SWAYAMYOU</h2>
        </div>

        <div className="footer-links">
          <a
            href="https://www.linkedin.com/in/jay-patel-785a08220/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            <FaLinkedin style={{ marginRight: '8px' }} />
            LinkedIn
          </a>
        </div>
      </div>

      <hr />

      <div className="footer-bottom">
        <p>© 2025 BitDustStash. All rights reserved.</p>
      </div>
    </footer>
  );
}
